import { render } from "./IconTextarea.vue?vue&type=template&id=5c4d1222"
import script from "./IconTextarea.vue?vue&type=script&lang=ts"
export * from "./IconTextarea.vue?vue&type=script&lang=ts"
script.render = render

export default script